// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"232":"3eb3ce03","834":"f92f9bf4"}[chunkId] + ".chunk.css";
};